import PropTypes from "prop-types";
import { isNil } from "ramda";

import FacePresenter from "presenters/FacePresenter";

import { Root, StyledResponsiveImage } from "./styles";

const DisplayFace = (props) => {
  const { face, onClick, clickable } = props;
  const asset = FacePresenter.asset(face);

  return (
    <Root>
      <StyledResponsiveImage
        draggable="false"
        src={asset}
        onClick={onClick}
        alt={!isNil(face?.person) ? "Person" : "Face"}
        role="presentation"
        clickable={clickable && !isNil(onClick)}
        width={86}
        widthMobile={56}
      />
    </Root>
  );
};

DisplayFace.propTypes = {
  face: FacePresenter.shape(),
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default DisplayFace;
